module.exports = __webpack_public_path__ + "static/media/ignore-icon.2067bfc3.svg";